import styled, { css } from 'styled-components';

import { spacing, transparencies } from 'styles/theme';

const LARGE_SIZE = '80px';
const X_LARGE_SIZE = '200px';

interface AvatarProps {
    $size?: 'small' | 'large' | 'xLarge';
}

export const InitialsWrapper = styled.div<AvatarProps>`
    border-radius: 1000px;
    background-color: ${transparencies.darkJungle5};
    width: ${spacing.xxLarge};
    height: ${spacing.xxLarge};
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    ${(props) =>
        props.$size === 'large'
            ? css`
                  width: ${LARGE_SIZE};
                  height: ${LARGE_SIZE};
              `
            : null}

    ${(props) =>
        props.$size === 'xLarge'
            ? css`
                  width: ${X_LARGE_SIZE};
                  height: ${X_LARGE_SIZE};
              `
            : null}
`;

export const AvatarImage = styled.img<AvatarProps>`
    border-radius: 1000px;
    width: ${spacing.xxLarge};
    height: ${spacing.xxLarge};
    flex-shrink: 0;
    object-fit: cover;

    ${(props) =>
        props.$size === 'large'
            ? css`
                  width: ${LARGE_SIZE};
                  height: ${LARGE_SIZE};
              `
            : null}

    ${(props) =>
        props.$size === 'xLarge'
            ? css`
                  width: ${X_LARGE_SIZE};
                  height: ${X_LARGE_SIZE};
              `
            : null}
`;
